'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  width: ', ';\n  height: ', ';\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  background-color: ', ';\n  color: ', ';\n  border-radius: 30px;\n  ', ';\n  font-weight: 700;\n  text-align: center;\n  user-select: none;\n  border: 1px solid ', ';\n\n  &:hover {\n    background-color: ', ';\n  }\n'], ['\n  width: ', ';\n  height: ', ';\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  background-color: ', ';\n  color: ', ';\n  border-radius: 30px;\n  ', ';\n  font-weight: 700;\n  text-align: center;\n  user-select: none;\n  border: 1px solid ', ';\n\n  &:hover {\n    background-color: ', ';\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _lurker = require('../../../util/lurker');

var _font = require('../../../util/font');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LINK = function LINK(props) {
  return _react2.default.createElement('a', props);
};
var Anchor = (0, _styledComponents2.default)(LINK)(_templateObject, function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.inverted ? '#ffffff' : '#f78323';
}, function (props) {
  return props.inverted ? '#f78323' : '#ffffff';
}, _font.fontSemiSmall, function (props) {
  return props.inverted ? '#f78323' : 'transparent';
}, function (props) {
  return props.inverted ? 'rgba(0,0,0,0.025)' : '#f99d53';
});

var handlePress = function handlePress(track) {
  return function () {
    return (0, _lurker.lurkerClickEvt)(track);
  };
};

var LinkButton = function LinkButton(props) {
  // eslint-disable-next-line
  var href = props.href,
      width = props.width,
      height = props.height,
      inverted = props.inverted,
      renderIcon = props.renderIcon,
      text = props.text,
      track = props.track,
      rest = (0, _objectWithoutProperties3.default)(props, ['href', 'width', 'height', 'inverted', 'renderIcon', 'text', 'track']);

  return _react2.default.createElement(
    Anchor,
    {
      href: href,
      width: width,
      height: height,
      inverted: inverted,
      onClick: handlePress(track)
    },
    renderIcon && renderIcon(),
    text
  );
};

LinkButton.propTypes = {
  renderIcon: _propTypes2.default.func,
  text: _propTypes2.default.string,
  href: _propTypes2.default.string,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  inverted: _propTypes2.default.bool
};

LinkButton.defaultProps = {
  href: '#'
};

exports.default = LinkButton;